module.exports = __webpack_public_path__ + "static/media/proj19_img7.ff1dae65.jpg";